const PICKUP_DATE_LOCALE = {
  days: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  months: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  monthsShort: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  today: "Today",
  clear: "Clear",
  dateFormat: "MMMM d, yyyy",
  timeFormat: "h:mm aa",
  firstDay: 0
};
const SLOT_OPEN_HOUR = 8;
const SLOT_CLOSE_HOUR = 20;
const SLOT_DURATION_HOURS = 2;
function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
function formatHour12(hour) {
  const period = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:00 ${period}`;
}
function formatSlotRange(startHour, endHour) {
  return `${formatHour12(startHour)} – ${formatHour12(endHour)}`;
}
function buildSlotDefinitions() {
  const slots = [];
  for (let start = SLOT_OPEN_HOUR; start + SLOT_DURATION_HOURS <= SLOT_CLOSE_HOUR; start += SLOT_DURATION_HOURS) {
    slots.push({ startHour: start, endHour: start + SLOT_DURATION_HOURS });
  }
  return slots;
}
const PICKUP_TIME_SLOTS = buildSlotDefinitions();
if (!customElements.get("pickup-date-picker")) {
  customElements.define(
    "pickup-date-picker",
    class PickupDatePicker extends HTMLElement {
      connectedCallback() {
        this.form = this.closest("form");
        this.input = this.querySelector(".pickup-date__input");
        this.errorWrapper = this.querySelector(".pickup-date__error");
        this.errorMessage = this.querySelector(".pickup-date__error-message");
        this.productForm = this.closest("product-form");
        this.selectedSlotStart = null;
        this.slotsPanel = null;
        if (!this.input || typeof AirDatepicker === "undefined") return;
        this.minDate = /* @__PURE__ */ new Date();
        this.maxDate = /* @__PURE__ */ new Date();
        this.maxDate.setMonth(this.maxDate.getMonth() + 2);
        this.maxDate.setHours(23, 59, 59, 999);
        this.datepicker = new AirDatepicker(this.input, {
          locale: PICKUP_DATE_LOCALE,
          classes: "air-datepicker--darling-dough air-datepicker--with-slots",
          timepicker: false,
          dateFormat: (date) => this.formatDisplayValue(date),
          minDate: this.minDate,
          maxDate: this.maxDate,
          autoClose: false,
          position: "bottom left",
          container: this.querySelector(".pickup-date__control"),
          buttons: ["clear"],
          onSelect: ({ date }) => this.onDateSelect(date),
          onShow: () => this.setupSlotLayout(),
          onHide: () => this.validate(false)
        });
        if (this.form) {
          this.form.addEventListener("submit", this.onFormSubmit.bind(this), true);
          this.bindBuyNowGuard();
        }
      }
      disconnectedCallback() {
        var _a, _b;
        (_a = this.buyNowObserver) == null ? void 0 : _a.disconnect();
        this.buyNowObserver = null;
        (_b = this.datepicker) == null ? void 0 : _b.destroy();
      }
      bindBuyNowGuard() {
        this.onBuyNowCaptureHandler = this.onBuyNowCaptureHandler || this.onBuyNowCapture.bind(this);
        this.attachBuyNowListeners();
        const buttonsWrapper = this.form.querySelector(
          ".product-form__buttons"
        );
        if (!buttonsWrapper || this.buyNowObserver) return;
        this.buyNowObserver = new MutationObserver(() => {
          this.attachBuyNowListeners();
        });
        this.buyNowObserver.observe(buttonsWrapper, {
          childList: true,
          subtree: true
        });
      }
      attachBuyNowListeners() {
        const targets = this.form.querySelectorAll(
          ".shopify-payment-button, shopify-accelerated-checkout"
        );
        targets.forEach((el) => {
          if (el.dataset.pickupBuyNowBound === "true") return;
          el.dataset.pickupBuyNowBound = "true";
          el.addEventListener("click", this.onBuyNowCaptureHandler, true);
        });
      }
      onBuyNowCapture(event) {
        var _a;
        const paymentRoot = event.target.closest(
          ".shopify-payment-button, shopify-accelerated-checkout"
        );
        if (!paymentRoot || !this.form.contains(paymentRoot)) return;
        const activeButton = event.target.closest('button, [role="button"]');
        if (activeButton && (activeButton.disabled || activeButton.getAttribute("aria-disabled") === "true")) {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (!this.validate(true)) {
          this.input.focus();
          (_a = this.datepicker) == null ? void 0 : _a.show();
          return;
        }
        this.addToCartAndCheckout();
      }
      async addToCartAndCheckout() {
        if (this.buyNowInProgress) return;
        this.buyNowInProgress = true;
        this.updateInputDisplay();
        try {
          const formData = new FormData(this.form);
          const response = await fetch(window.routes.cart_add_url, {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/json"
            },
            body: formData
          });
          const data = await response.json();
          if (data.status) {
            this.showError(
              data.description || "Could not add this item to your cart. Please try again."
            );
            return;
          }
          window.location.href = `${window.shopUrl || ""}/checkout`;
        } catch (error) {
          console.error(error);
          this.showError(
            "Could not proceed to checkout. Please try again."
          );
        } finally {
          this.buyNowInProgress = false;
        }
      }
      getPickerStrings() {
        return window.pickupDateStrings || {};
      }
      toDateOnly(date) {
        return new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate()
        );
      }
      getSelectedDayDate() {
        var _a, _b;
        const date = (_b = (_a = this.datepicker) == null ? void 0 : _a.selectedDates) == null ? void 0 : _b[0];
        return date ? this.toDateOnly(date) : null;
      }
      formatDisplayValue(date) {
        if (!date) return "";
        const day = this.toDateOnly(date);
        const base = this.datepicker.formatDate(day, "MMMM d, yyyy");
        if (this.selectedSlotStart === null) return base;
        return `${base} · ${formatSlotRange(
          this.selectedSlotStart,
          this.selectedSlotStart + SLOT_DURATION_HOURS
        )}`;
      }
      updateInputDisplay() {
        var _a, _b;
        const date = ((_b = (_a = this.datepicker) == null ? void 0 : _a.selectedDates) == null ? void 0 : _b[0]) ?? null;
        this.input.value = this.formatDisplayValue(date);
      }
      setupSlotLayout() {
        var _a, _b;
        const $dp = (_a = this.datepicker) == null ? void 0 : _a.$datepicker;
        if (!$dp) return;
        (_b = $dp.querySelector(".air-datepicker--time")) == null ? void 0 : _b.remove();
        const content = $dp.querySelector(".air-datepicker--content");
        if (!content) return;
        let layout = $dp.querySelector(".pickup-datepicker__layout");
        if (!layout || !layout.contains(content)) {
          layout == null ? void 0 : layout.remove();
          const strings = this.getPickerStrings();
          layout = document.createElement("div");
          layout.className = "pickup-datepicker__layout";
          content.parentNode.insertBefore(layout, content);
          const calendarCol = document.createElement("div");
          calendarCol.className = "pickup-datepicker__calendar";
          const dateLabel = document.createElement("p");
          dateLabel.className = "pickup-datepicker__section-label";
          dateLabel.textContent = strings.selectDate || "Select Date";
          calendarCol.appendChild(dateLabel);
          calendarCol.appendChild(content);
          layout.appendChild(calendarCol);
          this.slotsPanel = document.createElement("div");
          this.slotsPanel.className = "pickup-time-slots";
          layout.appendChild(this.slotsPanel);
        } else {
          this.slotsPanel = layout.querySelector(".pickup-time-slots");
          if (!this.slotsPanel) {
            this.slotsPanel = document.createElement("div");
            this.slotsPanel.className = "pickup-time-slots";
            layout.appendChild(this.slotsPanel);
          }
        }
        this.renderTimeSlots();
      }
      isSlotAvailable(date, startHour) {
        if (!date) return false;
        const slotStart = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          startHour,
          0,
          0,
          0
        );
        if (isSameDay(date, this.minDate) && slotStart <= this.minDate) {
          return false;
        }
        return true;
      }
      renderTimeSlots() {
        if (!this.slotsPanel) return;
        const strings = this.getPickerStrings();
        const timeSlotLabel = strings.selectTimeSlot || "Select Time Slot";
        const timeSlotHint = strings.timeSlotHint || "Select a date to see available times.";
        const date = this.getSelectedDayDate();
        if (!date) {
          this.slotsPanel.innerHTML = `
						<p class="pickup-time-slots__label">${timeSlotLabel}</p>
						<p class="pickup-time-slots__hint">${timeSlotHint}</p>
					`;
          return;
        }
        const slotsHtml = PICKUP_TIME_SLOTS.map(({ startHour, endHour }) => {
          const available = this.isSlotAvailable(date, startHour);
          const selected = this.selectedSlotStart === startHour;
          const label = formatSlotRange(startHour, endHour);
          return `
						<button
							type="button"
							class="pickup-time-slots__slot${selected ? " is-selected" : ""}"
							data-slot-hour="${startHour}"
							${available ? "" : "disabled"}
							aria-pressed="${selected}"
						>${label}</button>
					`;
        }).join("");
        this.slotsPanel.innerHTML = `
					<p class="pickup-time-slots__label">${timeSlotLabel}</p>
					<div class="pickup-time-slots__list" role="listbox" aria-label="${timeSlotLabel}">
						${slotsHtml}
					</div>
				`;
        this.slotsPanel.querySelectorAll(".pickup-time-slots__slot:not([disabled])").forEach((button) => {
          button.addEventListener("click", () => {
            this.onSlotSelect(Number(button.dataset.slotHour));
          });
        });
      }
      onDateSelect(date) {
        if (!date) {
          this.selectedSlotStart = null;
          this.updateInputDisplay();
          this.renderTimeSlots();
          return;
        }
        const nextDay = this.toDateOnly(date);
        const currentDay = this.getSelectedDayDate();
        const isNewDay = !currentDay || !isSameDay(nextDay, currentDay);
        if (isNewDay) {
          this.selectedSlotStart = null;
          this.datepicker.selectDate(nextDay, { silent: true });
          this.updateInputDisplay();
        }
        this.renderTimeSlots();
      }
      onSlotSelect(startHour) {
        const date = this.getSelectedDayDate();
        if (!date || !this.isSlotAvailable(date, startHour)) return;
        this.applySlot(date, startHour);
        this.datepicker.hide();
        this.validate(false);
      }
      applySlot(date, startHour) {
        const day = this.toDateOnly(date);
        const withTime = new Date(
          day.getFullYear(),
          day.getMonth(),
          day.getDate(),
          startHour,
          0,
          0,
          0
        );
        this.selectedSlotStart = startHour;
        this.datepicker.selectDate(withTime, { silent: true });
        this.updateInputDisplay();
        this.renderTimeSlots();
      }
      getSelectedDate() {
        const day = this.getSelectedDayDate();
        if (!day || this.selectedSlotStart === null) return null;
        return new Date(
          day.getFullYear(),
          day.getMonth(),
          day.getDate(),
          this.selectedSlotStart,
          0,
          0,
          0
        );
      }
      onFormSubmit(event) {
        var _a;
        if (!this.validate(true)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.input.focus();
          (_a = this.datepicker) == null ? void 0 : _a.show();
        }
      }
      validate(showError) {
        const strings = window.pickupDateStrings || {};
        const selected = this.getSelectedDate();
        const dateOnly = this.getSelectedDayDate();
        if (!dateOnly) {
          if (showError) {
            this.showError(
              strings.required || "Please select a pickup date and time."
            );
          }
          return false;
        }
        if (this.selectedSlotStart === null) {
          if (showError) {
            this.showError(
              strings.timeRequired || "Please select a pickup time slot."
            );
          }
          return false;
        }
        if (!selected || selected < this.minDate) {
          if (showError) {
            this.showError(
              strings.past || "Please select a future date and time."
            );
          }
          return false;
        }
        if (selected > this.maxDate) {
          if (showError) {
            this.showError(
              strings.maxRange || "Please select a date within the next 2 months."
            );
          }
          return false;
        }
        this.clearError();
        return true;
      }
      showError(message) {
        if (!this.errorWrapper || !this.errorMessage) {
          if (this.productForm) {
            const wrapper = this.productForm.querySelector(
              ".product-form__error-message-wrapper"
            );
            const errorEl = this.productForm.querySelector(
              ".product-form__error-message"
            );
            if (wrapper && errorEl) {
              wrapper.hidden = false;
              errorEl.textContent = message;
            }
          }
          return;
        }
        this.errorMessage.textContent = message;
        this.errorWrapper.classList.remove("hidden");
        this.input.setAttribute("aria-invalid", "true");
        this.input.setAttribute(
          "aria-describedby",
          this.errorWrapper.id || "pickup-date-error"
        );
      }
      clearError() {
        if (this.errorWrapper) {
          this.errorMessage.textContent = "";
          this.errorWrapper.classList.add("hidden");
        }
        this.input.removeAttribute("aria-invalid");
        this.input.removeAttribute("aria-describedby");
      }
    }
  );
}
//# sourceMappingURL=pickup-datepicker.js.map
